import useApi, { getCustomError } from 'common/hooks/useApi';
import useTypedSelector from 'common/hooks/useTypedSelector';
import { isActionCompleteFail } from 'common/services/api/isActionCompleteFail';
import { ActionCompleteResponse } from 'common/types/ApiResponse';
import ChsAddress from 'domain/types/ChsAddress';
import { useEffect, useState } from 'react';
import CancelRegistrationPresenter from './CancelRegistrationPresenter';
function CancelRegistration() {
  const [modalOpen, setModalOpen] = useState(false);
  const [
    registrationCancellationRequestResponse,
    registrationCancellationRequest,
  ] = useApi<ActionCompleteResponse>({
    method: 'POST',
    url: '/applications/requestCancellation',
  });

  const profileData = useTypedSelector((state) => state.profile.data);

  const [{ data: registrationAddresses }, getRegistrationAddresses] = useApi<
    Array<ChsAddress>
  >({
    url: `/applications/approvedRegistrationAddresses`,
    method: 'GET',
  });

  useEffect(() => {
    getRegistrationAddresses();
  }, [getRegistrationAddresses]);

  const submitRegistrationCancellation = async (
    values: Record<string, unknown>
  ) => {
    const response = await registrationCancellationRequest(values);
    if (isActionCompleteFail(response.data)) {
      return Promise.reject();
    } else {
      return Promise.resolve();
    }
  };

  let errors: string[] | null = null;
  if (isActionCompleteFail(registrationCancellationRequestResponse.data)) {
    errors = getCustomError(registrationCancellationRequestResponse.data).split(
      '\n'
    );
  } else if (Array.isArray(registrationCancellationRequestResponse.data)) {
    errors = registrationCancellationRequestResponse.data.map((d) => d.message);
  } else if (registrationCancellationRequestResponse.error) {
    errors = [registrationCancellationRequestResponse.error];
  }

  return (
    <CancelRegistrationPresenter
      profile={profileData}
      registrationAddresses={registrationAddresses}
      onCancelFormSubmit={submitRegistrationCancellation}
      cancelFormSubmitLoading={registrationCancellationRequestResponse.loading}
      cancelFormSubmitErrors={errors}
      isModalOpen={modalOpen}
      setModalOpen={setModalOpen}
    />
  );
}

export default CancelRegistration;
